import {ClipPath, Defs, G, Path, Rect, Svg} from 'react-native-svg';

const AcceptIcon = () => (
  <Svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <G clipPath="url(#clip0_394_2379)">
      <Path d="M2.5 8.5L8 14L15.5 4" stroke="white" strokeWidth="1.5" />
    </G>
    <Defs>
      <ClipPath id="clip0_394_2379">
        <Rect width="18" height="18" fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default AcceptIcon;
